var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#F4F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7754 30.4189C10.7754 28.9304 11.3667 27.5029 12.4192 26.4504C13.4717 25.3979 14.8992 24.8066 16.3876 24.8066H27.6121C29.1006 24.8066 30.5281 25.3979 31.5806 26.4504C32.6331 27.5029 33.2244 28.9304 33.2244 30.4189C33.2244 31.1631 32.9287 31.8769 32.4025 32.4031C31.8762 32.9294 31.1625 33.225 30.4182 33.225H13.5815C12.8373 33.225 12.1235 32.9294 11.5973 32.4031C11.071 31.8769 10.7754 31.1631 10.7754 30.4189Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0002 19.1942C24.3249 19.1942 26.2094 17.3097 26.2094 14.9851C26.2094 12.6604 24.3249 10.7759 22.0002 10.7759C19.6755 10.7759 17.791 12.6604 17.791 14.9851C17.791 17.3097 19.6755 19.1942 22.0002 19.1942Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.6210986e0777b699256e7b7ae105f1d9.svg";
export { ForwardRef as ReactComponent };